<template>
   <div class="image-field">
      <h6 class="label mb-2">Header Image</h6>
      <div class="image-dropzone" :class="{ active: isDragActive }">
         <Image
            :image="image"
            v-if="image?.src"
            fit="cover"
            :key="image?.src"
         />
         <div class="content">
            <div v-bind="getRootProps()">
               <input v-bind="getInputProps()" />
               <p>
                  Click ‘Upload Image’ or drag an image here to update the
                  classroom header image.
               </p>
               <Btn
                  action
                  @handleAction="openFile"
                  text="Upload Image"
                  buttonType="primary"
               >
                  <IconUpload />
               </Btn>
            </div>
            <div class="actions" v-if="!isDragActive">
               <Btn
                  v-if="image?.src"
                  action
                  @handleAction="removeFile"
                  :buttonType="['error']"
                  ><IconTrashcan
               /></Btn>
            </div>
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
import IconTrashcan from "~/assets/images/icons/trash.svg?component";
import IconUpload from "~/assets/images/icons/alt-upload-filled.svg?component";
import { useDropzone } from "vue3-dropzone";
// const authStore =  useAuthStore();
// const { getUser } = storeToRefs(authStore);
const emit = defineEmits(["uploadImage", "removeImage"]);

const props = defineProps({
   image: { type: Object, required: false },
});
const onDrop = (acceptFiles, rejectReasons) => {
   let formData = new FormData();
   formData.append("image", acceptFiles[0]);
   emit("uploadImage", formData);
};

const removeFile = () => {
   // await removeImage(formData);
   emit("removeImage");
};
const {
   getRootProps,
   getInputProps,
   isDragActive,
   open: openFile,
   ...rest
} = useDropzone({ onDrop, noClick: true });
</script>

<style lang="scss">
div.image-field {
   margin-top: pad(2);
}
div.image-dropzone {
   display: grid;
   padding: pad(2) pad(3);
   align-items: center;
   justify-items: center;
   column-gap: pad(2);
   background-color: $white;
   border-radius: pad(1);
   border: 1px solid $border;
   margin-bottom: pad(4);
   position: relative;
   overflow: hidden;
   height: 200px;

   figure {
      position: absolute;
      inset: 0;
      z-index: 0;
   }
   &.active {
      border-color: $jcc-blue;
      background-color: $blue-lt;
   }
   div.content {
      max-width: 400px;
      text-align: center;
      p {
         margin-bottom: pad(1);
      }
   }
   div.actions {
      margin-top: pad(1);
      gap: pad(1);
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      position: absolute;
      left: pad(1);
      bottom: pad(1);
      z-index: 0;
   }
}
</style>
